import { ButtonProps } from '@cxc/react-fpds-components';

export const LANDING_PAGE_MODAL_DATA = {
    TITLE: 'Disclaimer',
    DESCRIPTION: `The information on this website is being provided for convenience and informational purposes only. The contents and projected incentive estimates are compiled from third-party sites and publicly-available information, which remain subject to change or modification without notice. Ford Motor Company is not responsible for any content or program changes, and is not liable for any third-party information, incentives or third-party terms and conditions relating thereto.`,
    BUTTONS: [
        {
            name: 'Ok',
            id: 'ok',
            size: 'medium' as const,
            buttonColor: 'default' as const,
            buttonType: 'default' as const,
            as: 'button' as const,
        },
    ] as ButtonProps[],
};
